import {customAxios, GENERIC_URL, IDUSUARIO, TOKEN, USERNAME} from '../constants';
import {FETCH_ZONAS} from './types';
import {evalAction, serverError} from '../utils/actionError';

export function fetchZonas() {
    const config = {
        params: {
            codZona: 0,
            indInactivo: 'N',
        },
    };

    const request = customAxios.get(`${GENERIC_URL}/zona/zonas`, config)
        .then(({data}) => evalAction(data, 'listar'))
        .catch(error => serverError(error, 'listar'))

    return {
        type: FETCH_ZONAS,
        payload: request,
    };
}

/*REQ-86298*/
export function fetchObtenerClausulaComra() {
    const config = {
        headers: {
            idUsuario: IDUSUARIO,
            codUsuario: USERNAME,
            token: TOKEN
        },
    };

    const request = customAxios.post(`${GENERIC_URL}/clausulaCompras/listar`, config)
        .then(({data}) => evalAction(data, 'listar'))
        .catch(error => serverError(error, 'listar'))

    return {
        type: 'FETCH_CLAUSULAS',
        payload: request,
    };
}



// WEBPACK FOOTER //
// ./src/actions/Zonas.js